import React from 'react';

export default function useAudioRecorder(stream: MediaStream | null, ondataavailable: (data: ArrayBuffer) => void) {
  const streamRef = React.useRef<MediaStream | null>(null);
  React.useEffect(
    () => { streamRef.current = stream; },
    [stream],
  );

  React.useEffect(
    () => {
      let recorder: MediaRecorder | null = null;
      if (stream?.id) {
        recorder = new MediaRecorder(streamRef.current, { audioBitsPerSecond: 32000, mimeType: 'audio/webm;codecs=opus' });
        recorder.ondataavailable = async (e) => {
          const chunk = e.data;
          const arrayBuffer = await chunk.arrayBuffer();
          if (recorder.state === 'recording') {
            ondataavailable(arrayBuffer);
          }
        };
        recorder.start(400);
      }
      return () => {
        recorder?.stop();
      };
    },
    [streamRef, stream?.id],
  );
}
